module.exports = __webpack_public_path__ + "img/6fa4c28da87609b22be8411c0a1c7a21.png";